import { render, staticRenderFns } from "./OpportunityDetailsView.vue?vue&type=template&id=24c86820&scoped=true&"
import script from "./OpportunityDetailsView.vue?vue&type=script&lang=js&"
export * from "./OpportunityDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDetailsView.vue?vue&type=style&index=0&id=24c86820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c86820",
  null
  
)

export default component.exports